<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  props: {
    // click: Function,
    label: String,
    pending: Boolean,
    type: [Array, String],
    disabled: Boolean,
    nativeType: String,
  },
  methods: {
    // click_callback: function ($event) {
    //   this.$emit("click", $event);
    // },
  },
};
</script>

<template>
  <button
    class="keepfocus f-button"
    @click="$emit('click', $event)" 
    @mouseover="$emit('mouseover', $event)"
    @mouseleave="$emit('mouseleave', $event)" 
    :disabled="disabled"
    :class="[type, { pending }]" >
    <slot></slot>
    <i class="fa fa-circle-o-notch fa-spin fa-fw icon-pending"></i>
  </button>
</template>

<style lang="scss">
.f-button {
  outline: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 11px 22px;
  border: none;
  text-transform: uppercase;
  font-size: 14px;
  border-radius: 6px;
  font-family: Lato;
  font-weight: bold;
  position: relative;
  gap: 10px;
  text-align: center;
}

.f-button.small {
  font-size: 12px;
  padding: 0 16px;
  height: 40px;
  font-weight: 700;
}

/** Primary **/

.f-button.primary {
  background: var(--turquoise);
  border: 2px solid var(--turquoise);
  color: white;

  &:hover,
  &:focus {
    border: 2px solid var(--turquoise-d90);
    background-color: var(--turquoise-d90);
  }

  &.active,
  &:active,
  &:active:hover {
    border: 2px solid var(--turquoise-d80);
    background-color: var(--turquoise-d80);
  }

  i.fa.fa-circle-o-notch {
    color: white;
  }

  &[disabled]
  {
    opacity: 0.25;
  }
}

.f-button.primary.overlay {
  background: var(--white);
  border: 2px solid var(--white);
  color: var(--black);

  &:hover,
  &:focus {
    background: var(--black-l10);
    border: 2px solid var(--black-l10);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--black-l20);
    border: 2px solid var(--black-l20);
  }

  i.fa.fa-circle-o-notch {
    color: var(--black);
  }
}

.f-button.primary.negative {
  background: var(--statusNegative);
  border: 2px solid var(--statusNegative);
  color: var(--white);

  &:hover,
  &:focus {
    background: var(--interactiveStatusNegativeHover);
    border: 2px solid var(--interactiveStatusNegativeHover);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--interactiveStatusNegativePress);
    border: 2px solid var(--interactiveStatusNegativePress);
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}

/** Secondary **/

.f-button.secondary {
  background: transparent;
  color: var(--blue);
  border: 2px solid var(--blue-l75);

  &:hover,
  &:focus {
    background-color: var(--blue-l10);
  }

  &.active,
  &:active,
  &:active:hover {
    background-color: var(--blue-l20);
  }

  i.fa.fa-circle-o-notch {
    color: var(--blue);
  }

  &.disabled {
    opacity: 0.25;
  }
}

.f-button.secondary.overlay {
  background: transparent;
  color: var(--white);
  border: 2px solid var(--white);

  &:hover,
  &:focus {
    background-color: var(--white-a10);
  }

  &.active,
  &:active,
  &:active:hover {
    background-color: var(--white-a25);
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}

.f-button.secondary.negative {
  background: transparent;
  color: var(--statusNegative);
  border: 2px solid var(--statusNegative-a50);

  &:hover,
  &:focus {
    background: var(--statusNegative-a5);
    border: 2px solid var(--statusNegative-a50);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--statusNegative-a10);
    border: 2px solid var(--statusNegative-a50);
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}

/** Tertiary **/

.f-button.tertiary {
  background: transparent;
  color: #1890d3;
  text-decoration: none;
  border: 2px solid transparent;

  padding: 12px 8px;

  &:hover,
  &:focus {
    background: var(--interactiveBlueHover);
    border: 2px solid transparent;
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--interactiveBluePress);
    border: 2px solid transparent;
  }

  i.fa.fa-circle-o-notch {
    color: var(--blue);
  }
}

.f-button.tertiary.overlay {
  background: transparent;
  color: var(--white);
  border: 2px solid transparent;

  &:hover,
  &:focus {
    background-color: var(--white-a10);
    border: 2px solid transparent;
  }

  &.active,
  &:active,
  &:active:hover {
    background-color: var(--white-a25);
    border: 2px solid transparent;
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}

.f-button.tertiary.negative {
  background: transparent;
  color: var(--statusNegative);
  border: 2px solid transparent;

  &:hover,
  &:focus {
    background: var(--statusNegative-a5);
    border: 2px solid transparent;
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--statusNegative-a10);
    border: 2px solid transparent;
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}

.f-button.tertiary.notice {
  background: transparent;
  color: var(--statusNotice);
  border: 2px solid transparent;

  &:hover,
  &:focus {
    background: var(--statusNotice-a5);
    border: 2px solid transparent;
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--statusNotice-a10);
    border: 2px solid transparent;
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}

/** icon **/

.f-button.icon {
  background: transparent;
  color: var(--black);
  width: 40px;
  height: 40px;
  font-size: 18px;
  padding: 0px;

  &:hover,
  &:focus {
    background: rgba(24, 144, 211, 0.1);
  }

  &.active,
  &:active,
  &:active:hover {
    background: rgba(24, 144, 211, 0.25);
  }

  &.small {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }

  &.large {
    width: 48px;
    height: 48px;
    font-size: 24px;
  }
}

/** Highlight **/

.f-button.highlight {
  background: var(--yellow);
  border: 2px solid var(--yellow);
  color: var(--black);

  &:hover,
  &:focus {
    background: var(--yellow-d90);
    border: 2px solid var(--yellow-d90);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--yellow-d80);
    border: 2px solid var(--yellow-d80);
  }

  i.fa.fa-circle-o-notch {
    color: var(--black);
  }
}
/** Negative **/

.f-button.negative {
  background: var(--statusNegative);
  border: 2px solid var(--statusNegative);
  color: var(--white);

  &:hover,
  &:focus {
    background: var(--interactiveStatusNegativeHover);
    border: 2px solid var(--interactiveStatusNegativeHover);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--interactiveStatusNegativePress);
    border: 2px solid var(--interactiveStatusNegativePress);
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}
/** Notice **/

.f-button.notice {
  background: var(--statusNotice-l75);
  border: 2px solid var(--statusNotice-l75);
  color: var(--white);

  &:hover,
  &:focus {
    background: var(--interactiveStatusNoticeHover);
    border: 2px solid var(--interactiveStatusNoticeHover);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--interactiveStatusNoticePress);
    border: 2px solid var(--interactiveStatusNoticePress);
  }

  i.fa.fa-circle-o-notch {
    color: var(--white);
  }
}

/** Highlight **/

.f-button.danger {
  background: var(--statusNegative);
  border: 2px solid var(--statusNegative);
  color: var(--white);

  &:hover,
  &:focus {
    background: var(--interactiveStatusNegativeHover);
    border: 2px solid var(--interactiveStatusNegativeHover);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--interactiveStatusNegativePress);
    border: 2px solid var(--interactiveStatusNegativePress);
  }
}

.f-button.filled {
  background-color: var(--turquoise);
  border: 2px solid var(--turquoise);
  color: var(--white);

  &:hover,
  &:focus {
    background: var(--interactiveTurquoiseHover);
    border: 2px solid var(--interactiveTurquoiseHover);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--interactiveTurquoisePress);
    border: 2px solid var(--interactiveTurquoisePress);
  }
}

.f-button.transparent {
  background-color: transparent;
  border: 2px solid transparent;
  color: rgba(22, 22, 21, 1);

  &:hover,
  &:focus {
    background: var(--interactiveBlueHover);
  }

  &.active,
  &:active,
  &:active:hover {
    background: var(--interactiveBluePress);
  }
}

/** Link **/
.f-button.link {
  color: #1890d3;
  background: transparent;
  padding: 0;
  text-transform: none;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  gap: 6px;
  text-decoration: none;

  &.medium {
    font-size: 14px;
  }

  &.large {
    font-size: 16px;
  }

  &:hover,
  &:focus {
    background: transparent;
    text-decoration: underline;
  }

  &.active,
  &:active,
  &:active:hover {
    background: transparent;
    text-decoration: none;
  }

  i.fa.fa-circle-o-notch {
    color: var(--blue);
  }
}

.f-button:disabled {
  opacity: 0.25;
}

.f-button i.fa.fa-circle-o-notch {
  display: none;
}

.f-button.pending,
.f-button.pending.overlay {
  color: transparent;
  pointer-events: none;
}

.f-button.pending i.fa.fa-circle-o-notch,
.f-button.pending.overlay i.fa.fa-circle-o-notch {
  position: absolute;
  display: block;
  font-size: 16px;
}

.f-button.upthere {
  color: var(--white-a75);
  padding: 10px 12px;
  border-radius: 24px;
  cursor: pointer;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  background: var(--white-a5);

  &:hover {
    background: var(--white-a10);
  }

  &:active {
    background: var(--white-a25);
  }
}
</style>